/**
 * Vendor service — centralises all vendor/supplier-related API calls.
 *
 * Covers: vendor listing, vendor details, default pick-pack partner,
 * supplier integrations (connect, edit, disconnect), and vendor
 * relationship management.
 */
import api from './api'

// ---------------------------------------------------------------------------
// Vendor CRUD
// ---------------------------------------------------------------------------

export function getVendorList(filters = {}) {
  return api.post('/vendor/getVendorList', filters)
}

export function getVendorIsUsed(vendorId, distributorId) {
  return api.get(`/vendor/getVendorIsUsed/${vendorId}/${distributorId}`)
}

// getDefaultPickPack() removed -- endpoint dropped (card https://trello.com/c/90bFtNjs).

// patchVendorProductTypes() removed -- it PATCHed the /vendors/<id>/product_types
// relationship, which no longer exists: a vendor has exactly ONE product type
// (Jake, 2026-08-31) held on vendors.product_type_id. The function had no
// callers, so leaving it would have been a route to a 404 that reads like a
// supported API.

// ---------------------------------------------------------------------------
// Supplier Integrations
// ---------------------------------------------------------------------------

export function getIntegrationList() {
  return api.get('/supplier_integrations/getIntegrationList/')
}

export function getIntegration(integrationId, distributorId) {
  return api.get(`/supplier_integrations/getIntegration/${integrationId}/${distributorId}`)
}

export function verifyAndCreateNewConnection(data) {
  return api.post('/supplier_integrations/verifyAndCreateNewConnection', data)
}

export function verifyAndEditConnection(data) {
  return api.post('/supplier_integrations/verifyAndEditConnection', data)
}

export function disconnectIntegration(integrationId, distributorId) {
  return api.get(
    `/supplier_integrations/disconnectIntegration/${integrationId}/${distributorId}`
  )
}
